export const LOAD_TEST_RETRY_MAX_COUNT = 10
export const LOAD_TEST_RETRY_INTERVAL = 200
